import moment from "moment";

export function setVehicleDb(vehicles, prevVehicleDb) {
    return function(dispatch) {
        const vehicleDb = {...prevVehicleDb};
        for (var i = 0; i < vehicles.length; i++) {
            const vehicle = vehicles[i];
            const vId = vehicle.V_ID;

            if (!(vId in vehicleDb)) {
                vehicleDb[vId] = vehicle
            } else {
                var vehicle_keys = Object.keys(vehicle)
                for (var k = 0; k < vehicle_keys.length; k++) {
                    vehicleDb[vId][vehicle_keys[k]] = vehicle[vehicle_keys[k]]
                }
            }
        }

        dispatch({type: "SET_VEHICLE_DB", payload: vehicleDb})
    }
}

export function setProfileDb(profiles, prevProfileDb) {
    return function(dispatch) {
        var profileDb = prevProfileDb;
        for (var i = 0; i < profiles.length; i++) {
            //ignore invitations
            if(profiles[i].status != undefined && profiles[i].status == "Invited") {
                continue;
            }

            //profileDb[profiles[i].ID] = profiles[i]
            if (! (profiles[i].ID in profileDb)) {
                profileDb[profiles[i].ID] = profiles[i]
            } else {
                var profile_keys = Object.keys(profiles[i])
                for (var k = 0; k < profile_keys.length; k++) {
                    profileDb[profiles[i].ID][profile_keys[k]] = profiles[i][profile_keys[k]]
                }
            }
        }

        dispatch({type: "SET_PROFILE_DB", payload: profileDb})
    }
}

export function setBookingsDb(bookings, prevBookingDb) {
    return function(dispatch) {
        var bookingDb = prevBookingDb;
        for (var i = 0; i < bookings.length; i++) {
            var booking_item = {}
            var beginning_date = moment(bookings[i].Start_Date + " " + bookings[i].Release_Time);
            var ending_date = moment(bookings[i].End_Date + " " + bookings[i].Return_Time);
            booking_item["Booking"] = bookings[i]
            booking_item["Starting"] = beginning_date
            booking_item["Ending"] = ending_date
            if ('vmh' in bookings[i]) {
                if ("Turn_Pre" in bookings[i].vmh) {
                    booking_item["Starting_With_Turn"] = (beginning_date.clone().subtract(bookings[i].vmh.Turn_Pre, 'days')).subtract(bookings[i].vmh.Turn_Pre_Hours, 'hours')
                }

                if ("Turn_Post" in bookings[i].vmh) {
                    booking_item["Ending_With_Turn"] = (ending_date.clone().add(bookings[i].vmh.Turn_Pre, 'days')).add(bookings[i].vmh.Turn_Pre_Hours, 'hours')
                }
   
            }
            bookingDb[bookings[i].BOOK_ID] = booking_item;
        }

        dispatch({type: "SET_BOOKING_DB", payload: bookingDb})
    }
}

export function setReturnReleaseBookings(return_release_bookings) {
    return function(dispatch) {
        var return_release_bookings_dictionary = {}

        for (var i = 0; i < return_release_bookings.length; i++) {
            return_release_bookings_dictionary[return_release_bookings[i].BOOK_ID] = return_release_bookings[i]
        }

        dispatch({
            type: "SET_return_release", 
            payload: {
                return_release_bookings: return_release_bookings,
                return_release_bookings_dictionary: return_release_bookings_dictionary
            }
        })
    }
}

export function goSurvey(survey) {
    return function(dispatch) {
        dispatch({type: "SET_SURVEY", payload: survey})
    }
}

export function setupOptimizedBookings() {
    return function(dispatch) {
        
    }
}